import { render, staticRenderFns } from "./MatchingClientsAlert.vue?vue&type=template&id=0d722303&lang=pug"
import script from "./MatchingClientsAlert.vue?vue&type=script&lang=js"
export * from "./MatchingClientsAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default,Name: require('/home/docker/code/frontend/components/Name.vue').default,AgeLocation: require('/home/docker/code/frontend/components/AgeLocation.vue').default})
